import {
  add, divide,
  getTheoreticalPrice,
  VehicleWebViewFiltersWithPaging,
  vehicleWebViewSortOptions
} from "@amsanalytics/react-shared-library";
import {CuratedSiteApplicationConfig} from "../../../Models/CuratedSiteApplicationConfig";
import {getEffectiveMaxMonthlyPayment} from "./monthlyPaymentCap";

export const getDefaultFilters = (curatedSiteApplicationConfig: CuratedSiteApplicationConfig): VehicleWebViewFiltersWithPaging => {
  let downPaymentToUse = curatedSiteApplicationConfig.downPaymentOnCreditApplication;
  if (downPaymentToUse < curatedSiteApplicationConfig.minDown) {
    // If the down payment is less than the min, then use the min.
    downPaymentToUse = curatedSiteApplicationConfig.minDown;
  }

  if (downPaymentToUse > curatedSiteApplicationConfig.maxDown) {
    // If the down payment is more than the max, then use the max.
    downPaymentToUse = curatedSiteApplicationConfig.maxDown;
  }

  // Cap the effective max monthly payment by the down-payment-based limit (whole dollars)
  const effectiveMaxMonthlyPayment = getEffectiveMaxMonthlyPayment(
    curatedSiteApplicationConfig.minMonthlyPayment,
    curatedSiteApplicationConfig.maxMonthlyPayment,
    curatedSiteApplicationConfig.paymentPercentOfMonthlyIncome,
    downPaymentToUse
  );

  const monthlyPaymentToUse = Math.round(
    divide(add(curatedSiteApplicationConfig.minMonthlyPayment, effectiveMaxMonthlyPayment), 2)
  ); // getting the average / middle of the valid range
  
  const maxPrice = getTheoreticalPrice(monthlyPaymentToUse, curatedSiteApplicationConfig.breakevenMonths, downPaymentToUse, curatedSiteApplicationConfig.overhead);
  const currentYear = new Date().getFullYear();
  const yearRange = { start: currentYear - 25, end: currentYear + 1 };
  
  return {
    searchText: '',
    sortBy: vehicleWebViewSortOptions.find(o => o.label === curatedSiteApplicationConfig.sortByLabel),
    monthlyPayment: monthlyPaymentToUse,
    downPayment: downPaymentToUse,
    maxPrice: maxPrice,
    yearRange: yearRange,
    make: 'All',
    model: 'All',
    carOrTruck: 'All',
    skip: 0,
    take: 20
  }
};
